import { Section } from '@globaleris/ui.library'

// This validator is used to validate than AT LEAST ONE FIELD is filled in a Form.
export const minimumOneFieldFilled = (sections: Section[], formState: any): boolean => {
  return sections.some(section =>
    section.inputs.some(input => {
      if (input.display === false) return false
      if (input.type !== 'SEARCHFIELD') {
        const split = input.name.split('.')
        let value
        if (split.length > 1) {
          if (formState[split[0]]) {
            value = formState[split[0]][split[1]]
          } else {
            value = undefined
          }
        } else {
          value = formState[input.name]
        }

        const isPropInForm =
          (value != null && typeof value === 'number') ||
          (value != null && value instanceof Date) ||
          (value != null && value?.length > 0 && value !== '')

        if (isPropInForm) {
          return true
        }
      } else {
        // Validate searchField is filled
        console.log('searchField', input, formState)
        return formState[input.name]?.value != null
      }
    })
  )
}

// This validator is used to validate required inputs are filled in a Form when Save button is clicked.
// Must be called inside save handler, where we have access to formState object.
// If there's any prop we want the validator to avoid (since will be coming from another component) we can just pass it as 3rd parameter string[].

export const missingFieldsForm = (
  sections: Section[],
  formState: any,
  avoidableProps?: string[]
): boolean => {
  return sections.some(section =>
    section.inputs.some(input => {
      if (input.display === false) return false
      if (input.required && input.type !== 'SEARCHFIELD') {
        // This Prop is required by the Form and needs to exists in the given formState.
        const split = input.name.split('.')
        let value
        if (split.length > 1) {
          if (formState[split[0]]) {
            value = formState[split[0]][split[1]]
          } else {
            value = undefined
          }
        } else {
          value = formState[input.name]
        }

        const isPropInForm = value !== undefined

        // This prop comes from another form or component and will be validated afterwards.
        const isPropAvoidable = avoidableProps
          ? avoidableProps.find(prop => prop === input.name)
            ? true
            : false
          : false

        if (
          (!isPropInForm && !isPropAvoidable) ||
          (typeof isPropInForm === 'object' &&
            typeof isPropInForm !== typeof new Date() &&
            Object.keys(isPropInForm).length === 0)
        ) {
          console.log('MISSING', input, formState)
          return true
        }
      }
    })
  )
}

// this helper is meant to improve missingFieldsForm without affecting already running pages
// currently, missingFieldsForms omits a REQUIRED text field when the user manually erase
// the field, sending '' (string null) to POST/PATCH api call
export const missingFieldsFormWithRequiredText = (
  sections: Section[],
  formState: any,
  avoidableProps?: string[]
): boolean => {
  return sections.some(section =>
    section.inputs.some(input => {
      if (input.display === false) return false
      if (input.required && input.type !== 'SEARCHFIELD') {
        // This Prop is required by the Form and needs to exists in the given formState.
        const split = input.name.split('.')
        let value
        if (split.length > 1) {
          if (formState[split[0]]) {
            value = formState[split[0]][split[1]]
          } else {
            value = undefined
          }
        } else {
          value = formState[input.name]
        }

        const isPropInForm = value !== undefined && value !== null && value !== ''

        // This prop comes from another form or component and will be validated afterwards.
        const isPropAvoidable = avoidableProps
          ? avoidableProps.find(prop => prop === input.name)
            ? true
            : false
          : false

        if (
          (!isPropInForm && !isPropAvoidable) ||
          (typeof isPropInForm === 'object' &&
            typeof isPropInForm !== typeof new Date() &&
            Object.keys(isPropInForm).length === 0)
        ) {
          console.log('MISSING', input, formState)
          return true
        }
      }
    })
  )
}
